import { alpha } from '@mui/material';

import { PLAN_REVISION_FLAG_TIMEOUT_MS } from 'constants/aiChat';

const REPLAN_PULSE_START_ALPHA = 0.4;
const REPLAN_PULSE_END_ALPHA = 0;

const baseAccordionRootStyles = {
  boxShadow: 'none',
  borderRadius: '8px !important',
  border: '1px solid',
  borderColor: 'divider',
  '&:not(:last-of-type)': {
    borderBottom: '1px solid',
    borderBottomColor: 'divider',
  },
  '&::before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    margin: 0,
  },
};

export const actionStepAccordionStyles = {
  '&.MuiAccordion-root': {
    ...baseAccordionRootStyles,
    backgroundColor: 'background.secondary',
  },
};

export const activeActionStepAccordionStyles = {
  '&.MuiAccordion-root': {
    ...baseAccordionRootStyles,
    backgroundColor: 'primary.soft',
  },
};

export const actionStepAccordionSummaryStyles = {
  '&.MuiAccordionSummary-root': {
    minHeight: 'unset',
    padding: '6px 8px',
    '&.Mui-expanded': {
      minHeight: 'unset',
    },
  },
  '& .MuiAccordionSummary-content': {
    margin: 0,
    minWidth: 0,
    '&.Mui-expanded': {
      margin: 0,
    },
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    display: 'none',
  },
};

export const actionStepAccordionSummaryNonExpandableStyles = {
  ...actionStepAccordionSummaryStyles,
  '&.MuiAccordionSummary-root': {
    ...actionStepAccordionSummaryStyles['&.MuiAccordionSummary-root'],
    cursor: 'default',
  },
};

export const actionStepAccordionDetailsStyles = {
  '&.MuiAccordionDetails-root': {
    padding: '4px 8px 8px 32px',
    backgroundColor: 'background.primary',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
  },
};

export const actionStepSummaryWrapperStyles = {
  width: '100%',
  gap: '4px',
  alignItems: 'flex-start',
};

export const actionStepDescriptionStyles = {
  color: 'text.secondary',
  paddingLeft: '32px',
};

export const actionStepErrorPreviewStyles = {
  color: 'error.main',
  paddingLeft: '32px',
};

export const replanPulseStyles = theme => {
  const startColor = alpha(theme.palette.primary.main, REPLAN_PULSE_START_ALPHA);
  const endColor = alpha(theme.palette.primary.main, REPLAN_PULSE_END_ALPHA);

  return {
    '@keyframes replanBorderPulse': {
      '0%': { boxShadow: `0 0 0 0 ${startColor}` },
      '70%': { boxShadow: `0 0 0 6px ${endColor}` },
      '100%': { boxShadow: `0 0 0 0 ${endColor}` },
    },
    animation: `replanBorderPulse ${PLAN_REVISION_FLAG_TIMEOUT_MS}ms ease-out 1`,
    borderRadius: '4px',
  };
};

export const scannedSectionsContainerStyles = {
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '6px',
  marginTop: '4px',
  paddingLeft: '32px',
};

export const scannedSectionChipStyles = {
  '@keyframes scannedSectionScaleIn': {
    '0%': { transform: 'scale(0.8)', opacity: 0 },
    '100%': { transform: 'scale(1)', opacity: 1 },
  },
  animation: 'scannedSectionScaleIn 200ms cubic-bezier(0.34, 1.56, 0.64, 1) forwards',
  height: '24px',
  borderRadius: '4px',
  backgroundColor: 'background.secondary',
  border: '1px solid',
  borderColor: 'divider',
  '& .MuiChip-label': {
    paddingLeft: '8px',
    paddingRight: '8px',
    fontSize: '0.75rem',
    fontWeight: 500,
    color: 'text.primary',
  },
};
